import React from 'react';

const DevicePhone = ({ ...props }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.16667 3.33333H10.8333M10 14.1667V14.175M5 4.16667C5 3.72464 5.17559 3.30072 5.48816 2.98816C5.80072 2.67559 6.22464 2.5 6.66667 2.5H13.3333C13.7754 2.5 14.1993 2.67559 14.5118 2.98816C14.8244 3.30072 15 3.72464 15 4.16667V15.8333C15 16.2754 14.8244 16.6993 14.5118 17.0118C14.1993 17.3244 13.7754 17.5 13.3333 17.5H6.66667C6.22464 17.5 5.80072 17.3244 5.48816 17.0118C5.17559 16.6993 5 16.2754 5 15.8333V4.16667Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
DevicePhone.displayName = "Icons.DevicePhone";

export { DevicePhone };
//# sourceMappingURL=DevicePhone.js.map
